export default "__VITE_ASSET__C7oDBS2n__"